<template>
  <LegalDocumentPage :document="dataConsent" @close="$emit('close')" />
</template>

<script setup lang="ts">
import { dataConsent } from "../../content/legalDocuments";
import LegalDocumentPage from "../LegalDocumentPage.vue";

defineEmits<{
  (event: "close"): void;
}>();
</script>
